import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { TeamNavBar } from "src/components/compounds/TeamNavBar/TeamNavBar";
import { MainGrid } from "src/components/atoms/MainGrid/MainGrid";
import { useGetTeamByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";
import ErrorBoundary from "src/components/atoms/ErrorBoundary/ErrorBoundary";
import * as Team from "src/state/modules/team";
import { addRecentlyViewed } from "src/utils/recently-viewed";

export const PageLayout = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetTeamByIDQuery(id ?? "");

  // Feed the search page's "Recently Viewed" list.
  useEffect(() => {
    if (!data?.id) return;
    addRecentlyViewed({
      id: data.id,
      name: data.name,
      sport: data.sport,
      seasonName: data.seasonName,
      seasonYear: data.seasonYear,
      city: data.city ?? undefined,
      state: data.state ?? undefined,
      staff: data.staff,
    });
  }, [data]);

  if (isLoading) return <PageLoader1 />;

  return (
    <MainGrid>
      <TeamNavBar team={data ?? ({} as Team.Team)} />
      <ErrorBoundary>
        <Outlet context={data} />
      </ErrorBoundary>
    </MainGrid>
  );
};
